import { render, staticRenderFns } from "./BillingTransactionsRentalTab.vue?vue&type=template&id=0fc7350c"
import script from "./BillingTransactionsRentalTab.vue?vue&type=script&lang=js"
export * from "./BillingTransactionsRentalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports